var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 172,
    viewBox: "0 0 171 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_7399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.488 59.324C123.12 58.64 121.068 58.64 119.7 59.324L77.292 103.1L57.456 82.58C56.088 81.212 54.036 81.212 52.668 82.58C51.3 83.948 51.3 86 51.984 87.368L74.556 109.94H75.24C75.24 109.94 75.924 109.94 75.924 110.624H78.66C78.66 110.624 79.344 110.624 79.344 109.94H80.028L125.172 64.112C125.172 62.744 125.172 60.692 124.488 59.324Z",
    fill: "#43B000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 171.5C38.304 171.5 0 133.196 0 86C0 38.804 38.304 0.5 85.5 0.5C132.696 0.5 171 38.804 171 86C171 133.196 132.696 171.5 85.5 171.5ZM85.5 7.34C42.408 7.34 6.84 42.908 6.84 86C6.84 129.092 42.408 164.66 85.5 164.66C128.592 164.66 164.16 129.092 164.16 86C164.16 42.908 128.592 7.34 85.5 7.34Z",
    fill: "#43B000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_7399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 171,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/successImg.c8c794d5e8139e3f974d41e69c87fa3d.svg";
export { ForwardRef as ReactComponent };